/**
 * Geo Resource Client
 * API client for IP geolocation endpoint
 */

import { ApiClient } from './apiClient';

export interface GeoLocationData {
    ip_address?: string | null;
    city?: string | null;
    region?: string | null;
    region_iso_code?: string | null;
    postal_code?: string | null;
    country?: string | null;
    country_code?: string | null;
    country_is_eu?: boolean | null;
    continent?: string | null;
    continent_code?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    security?: {
        is_vpn?: boolean | null;
    } | null;
    timezone?: {
        name?: string | null;
        abbreviation?: string | null;
        gmt_offset?: number | null;
        current_time?: string | null;
        is_dst?: boolean | null;
    } | null;
    currency?: {
        currency_name?: string | null;
        currency_code?: string | null;
    } | null;
}

export class GeoResource {
    constructor(private apiClient: ApiClient) {}

    /**
     * Get geolocation data from the visitor's IP address
     */
    async getGeoLocation(): Promise<GeoLocationData> {
        return this.apiClient.get('/api/v1/geo');
    }

    /**
     * Get geolocation data for a specific IP address
     */
    async getGeoLocationByIp(ip: string): Promise<GeoLocationData> {
        return this.apiClient.get(`/api/v1/geo?ip=${encodeURIComponent(ip)}`);
    }

    /**
     * Convenience: get just the country code from IP geolocation
     * Returns ISO 3166-1 alpha-2 code (e.g. 'US', 'FR') or null
     */
    async detectCountry(): Promise<string | null> {
        try {
            const data = await this.getGeoLocation();
            const code = data?.country_code;
            return code && typeof code === 'string' && code.length === 2 ? code : null;
        } catch {
            return null;
        }
    }
}
